var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('el-timeline',_vm._l((_vm.resultData),function(item){return _c('el-timeline-item',{key:(item.id),attrs:{"timestamp":item.date,"placement":"top"}},[_c('el-card',[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(item.comment.replace(/\n/g,'<br>'))}})])],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }